<script setup>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  category: {
    type: Object,
    default: null
  },
  deleting: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close', 'confirm'])
</script>

<template>
  <Dialog
    :visible="props.visible"
    modal
    :closable="!props.deleting"
    :close-on-escape="!props.deleting"
    header="Подтверждение удаления"
    :style="{ width: 'min(460px, 95vw)' }"
    @update:visible="emit('close')"
  >
    <div class="confirm-content">
      <p>
        Вы действительно хотите удалить категорию
        <strong>{{ props.category?.name || '—' }}</strong>?
      </p>

      <p class="warning-text">
        Если у категории есть дочерние категории, сервер может не дать её удалить.
      </p>
    </div>

    <template #footer>
      <Button
        label="Отмена"
        severity="secondary"
        outlined
        :disabled="props.deleting"
        @click="emit('close')"
      />
      <Button
        label="Удалить"
        icon="pi pi-trash"
        severity="danger"
        :loading="props.deleting"
        :disabled="props.deleting"
        @click="emit('confirm')"
      />
    </template>
  </Dialog>
</template>

<style scoped>
.confirm-content {
  font-size: 15px;
  line-height: 1.5;
}

.warning-text {
  color: #b45309;
  margin-top: 10px;
}
</style>